/** @jsx jsx */

import { jsx } from '@emotion/core';
import { Tag, Text } from '@zapier/design-system';

import Link from 'app/common/components/Link';
import { PLATFORM_MARKETING_BASE_URL } from 'app/developer-v3/constants';

import Styles from './TierGraph.styles';
import TierSvgWrapper from './TierSvgWrapper';
import { TIERS_MAP } from './constants';

const TierTooltip = ({ className, isActive, tier }) => {
  const prevLevel = tier.prev && TIERS_MAP[tier.prev];

  return (
    <div className={['tier-tooltip', className].join(' ')} css={Styles.tooltip}>
      <figure css={Styles.tooltipTrophy}>
        <TierSvgWrapper iconType={{ isTooltip: true }} tier={tier.key} />
      </figure>
      {isActive && <Tag>Your Level</Tag>}
      <Text margin="5px 0px 15px" tag="div" textAlign="center" type="Body4">
        {tier.label} Level Perks
      </Text>
      <div css={Styles.levelPerksContent}>
        {prevLevel && (
          <Text color="GrayWarm7" tag="div" textAlign="left">
            All the benefits of {prevLevel.label}{' '}
            <Text color="GrayWarm7" fontWeight={600}>
              plus...
            </Text>
          </Text>
        )}
        <ul css={Styles.levelPerksList}>
          {tier.perks.map((perk, i) => (
            <li css={Styles.levelPerksListItem} key={i}>
              {perk}
            </li>
          ))}
        </ul>
        <Link href={`${PLATFORM_MARKETING_BASE_URL}/partner-program/`}>
          Compare all benefits
        </Link>
      </div>
    </div>
  );
};

export default TierTooltip;
